import { createFileRoute } from '@tanstack/react-router';
import { UserDetail } from '@/features/users/UserDetail';

export const Route = createFileRoute('/_shell/users/$userId')({
  component: UserDetailRoute,
});

function UserDetailRoute() {
  const { userId } = Route.useParams();
  return <UserDetail userId={userId} />;
}
